<script lang="ts">
  import ButtonLink from '@athena-lib/Button/ButtonLink/ButtonLink.svelte';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { LeftToFreeShipping, type LeftToFreeShippingProps } from '@athena-lib/LeftToFreeShipping';
  import OrderTotal, { type OrderTotalProps } from '@athena-lib/OrderTotal/OrderTotal.svelte';
  import QuoteCard, { type QuoteCardProps } from '@athena-lib/QuoteCard/QuoteCard.svelte';
  import { Text, HeadingMedium, HeadingSmall } from '@athena-lib/Text';
  import type { Snippet } from 'svelte';
  import {
    CustomStickersBundle,
    type CustomStickersBundleProps,
  } from '@athena-lib/CustomStickersBundle';
  const {
    orderTotal,
    leftToFreeShipping,
    quoteCards,
    customStickersBundle,
    checkoutUrl,
    onClick,
    reviewCartUrl,
    expressCheckoutElementId,
    expectedDelivery,
  }: {
    orderTotal: OrderTotalProps;
    customStickersBundle?: CustomStickersBundleProps;
    leftToFreeShipping?: LeftToFreeShippingProps;
    quoteCards: Array<QuoteCardProps>;
    checkoutUrl: string;
    reviewCartUrl: string;
    onClick: () => void;
    expressCheckoutElementId?: string;
    expectedDelivery?: Snippet;
  } = $props();
  const translations = getCommonTranslations();
</script>

<div class="flex h-full flex-col">
  <div class="mb-10 flex flex-col justify-center gap-5 px-5 pb-5 pt-14">
    <div>
      <HeadingMedium size="small">{translations.myCart}</HeadingMedium>
      {#if expectedDelivery}
        {@render expectedDelivery()}
      {/if}
    </div>
    {#if leftToFreeShipping}
      <LeftToFreeShipping {...leftToFreeShipping} />
    {/if}
    <div class="flex flex-col gap-2">
      {#each quoteCards as quoteCard}
        <QuoteCard {...quoteCard} />
      {/each}
    </div>
    {#if customStickersBundle}
      <CustomStickersBundle {...customStickersBundle} />
    {/if}

    <HeadingSmall size="xxsmall">{translations.orderSummary}</HeadingSmall>
    <OrderTotal {...orderTotal}></OrderTotal>
    {#if expressCheckoutElementId}
      <div class="flex flex-row justify-center">
        <Text color="medium" size="xsmall">{translations.expressCheckout}</Text>
      </div>
      <div id={expressCheckoutElementId}></div>
    {/if}
  </div>

  <div
    class="sticky bottom-0 mt-auto bg-st-white px-5 py-4 shadow drop-shadow-[0_-3px_4px_rgba(0,0,0,0.25)]"
  >
    <div class="flex flex-row place-items-center gap-4">
      <a
        href={reviewCartUrl}
        color="dark"
        class="w-1/2 basis-auto text-center align-middle font-bold underline"
        onclick={onClick}
      >
        {translations.reviewCart}
      </a>
      <ButtonLink class="basis-auto" link={{ href: checkoutUrl }} {onClick}
        >{translations.checkoutNow}</ButtonLink
      >
    </div>
  </div>
</div>
